import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from 'store/actions/routes';

import { RouteResponse, Destinos } from 'store/types/routes';

const initialState: RouteResponse = {
  destinationId: [],
};

export const RoutesReducer = createReducer<RouteResponse, ActionType<typeof actions>>(initialState).handleAction(
  actions.getRoute.success,
  (state, { payload }) => ({
    ...state,
    destinationId: [...payload],
  }),
);
